import React from 'react';
import { CircularProgress as MuiCircularProgress } from '@material-ui/core';

const CircularProgress = props => <MuiCircularProgress {...props} />;

export default CircularProgress;
